export default {
    priority1: 'Priority 1 (First Choice)',
    priority2: 'Priority 2 (Second Choice)',
    priority3: 'Priority 3 (Last Resort)',
};
